import { FC } from "react";

const Calendar: FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_229_1448)">
        <path
          d="M12.6667 2.66629H3.33333C2.59695 2.66629 2 3.26324 2 3.99962V13.333C2 14.0693 2.59695 14.6663 3.33333 14.6663H12.6667C13.403 14.6663 14 14.0693 14 13.333V3.99962C14 3.26324 13.403 2.66629 12.6667 2.66629Z"
          stroke="black"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6667 1.33298V3.99964"
          stroke="black"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33325 1.33298V3.99964"
          stroke="black"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 6.66629H14"
          stroke="black"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_229_1448">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 -0.000366211)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Calendar;
